module.exports = __webpack_public_path__ + "media/images/weleda_logo_admin-c587d1b07c20682b94151010c86b59bf.png";